module.exports = __webpack_public_path__ + "img/fish_bobotie.551a4a85.jpeg";